// @ts-nocheck

import optimist from 'redux-optimist';

import animations from '../modules/animations/reducers/animations';
import betslipOptions from '../modules/betslip-options/reducers/betslipOptions';
import boom from '../modules/boom/reducers/boom';
import clientUpdaterReducer from '../modules/client-updater/reducers/clientUpdater';
import gr from '../modules/gift-race/reducers/gr';
import grids from '../modules/grids/reducers';
import immersive from '../modules/immersive/reducers/immersive';
import kl from '../modules/koh-lanta/reducers/kl';
import makeUserMissionsReducer from '../modules/missions/reducers/userMissions';
import mp from '../modules/monopoly/reducers/mp';
import combineReducers from '../utils/combineReducers';

import getBasketReducer from './basket';
import betbuilder from './betbuilder';
import betFilter from './betFilter';
import cashout from './cashout';
import makeEntitiesReducer from './entities';
import favorites from './favorites';
import flashmessages from './flashmessages';
import historyReducer from './history';
import menu from './menu';
import misc from './misc';
import multiview from './multiview';
import mymatch from './mymatch';
import network from './network';
import overlay from './overlay';
import previouspages from './previouspages';
import regulation from './regulation';
import review from './review';
import runtime from './runtime';
import search from './search';
import makeUserReducer from './user';

const getRootReducer = (history) =>
  combineReducers({
    user: makeUserReducer(history),
    runtime,
    basket: getBasketReducer(),
    entities: makeEntitiesReducer(history),
    favorites: optimist(favorites),
    betslipOptions,
    flashmessages,
    menu,
    multiview,
    history: historyReducer,
    cashout,
    betbuilder,
    network,
    search,
    review,
    immersive,
    clientUpdater: clientUpdaterReducer,
    betFilter,
    grids,
    kl,
    misc,
    overlay,
    userMissions: makeUserMissionsReducer(history),
    animations,
    gr,
    mp,
    previouspages,
    mymatch,
    boom,
    regulation,
  });

export default getRootReducer;
